import Cookies from 'js-cookie'

const TokenKey = 'login_token'
// let TokenKey

export function getToken() {
  const token = Cookies.get(TokenKey)
  return token && Object.prototype.toString.call(token) === '[object String]' ? token : ''
}

export function setToken(token) {
  // TokenKey = `admin_token${token.slice(0, 11)}`
  // return Cookies.set(`admin_token${token.slice(0, 11)}`, token)
  return Cookies.set(TokenKey, token)
}

export function getScreenState() {
  return parseInt(Cookies.get('screenState'))
}

export function setScreenState(state) {
  return Cookies.set('screenState', state)
}

export function removeScreenState() {
  return Cookies.remove('screenState')
}

export function getCommunityId() {
  return Cookies.get('communityId')
}

export function setCommunityId(id) {
  return Cookies.set('communityId', id)
}

export function getCommunityName() {
  return Cookies.get('communityName')
}

export function setCommunityName(communityName) {
  return Cookies.set('communityName', communityName)
}

export function setOrganizationId(organizationId) {
  return Cookies.set('organizationId', organizationId)
}

export function getOrganizationId() {
  return Cookies.get('organizationId')
}

export function setOrganizationName(organizationName) {
  return Cookies.set('organizationName', organizationName)
}

export function getOrganizationName() {
  return Cookies.get('organizationName')
}

export function setCurrentIndex(index) {
  return Cookies.set('currentIndex', index)
}

export function getCurrentIndex() {
  return Cookies.get('currentIndex')
}

export function getFirstCommunityId() {
  return Cookies.get('firstCommunityId')
}

export function setFirstCommunityId(value) {
  return Cookies.set('firstCommunityId', value)
}

export function getCurrentOrganizationId() {
  return Cookies.get('currentOrganizationId')
}

export function setCurrentOrganizationId(value) {
  return Cookies.set('currentOrganizationId', value)
}

export function getRoutesCut() {
  return Cookies.get('routesCut')
}
export function setRoutesCut(value) {
  return Cookies.set('routesCut', value)
}
export function getNoteIsGenerate() {
  return Cookies.get('noteIsGenerate')
}
export function setNoteIsGenerate(value) {
  return Cookies.set('noteIsGenerate', value)
}

export function removeNoteIsGenerate() {
  Cookies.remove('noteIsGenerate')
}

export function removeToken() {
  Cookies.remove('communityId')
  Cookies.remove('communityName')
  Cookies.remove('screenState')
  Cookies.remove('organizationName')
  Cookies.remove('organizationId')
  Cookies.remove('currentIndex')
  Cookies.remove('firstCommunityId')
  Cookies.remove('currentOrganizationId')
  Cookies.remove('routesCut')
  Cookies.remove('noteIsGenerate')

  Cookies.remove(TokenKey)
}
